"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SearchTermHighlighter = ({ searchTerm, children }) => {
    if (!searchTerm) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    const regex = new RegExp(`(${searchTerm})`, 'gi');
    const highlighted = children
        .split(regex)
        .map((part, i) => regex.test(part) ? (react_1.default.createElement("strong", { key: `${part}${i}` }, part)) : (react_1.default.createElement("span", { key: `${part}${i}` }, part)));
    return react_1.default.createElement(react_1.default.Fragment, null, highlighted);
};
exports.default = SearchTermHighlighter;
//# sourceMappingURL=search-term-highlighter.js.map